<template lang="pug">
    div(class="flex mt-5 h-12")
        div(
            v-if="qtySelector.enabled"
            class="flex shrink h-full"
            style="min-width: 76px;"
        )
            div(class="select w-full h-full rounded-l" :class="{'border border-r-0 is-disabled':disabled}")
                select(
                    v-model="qty"
                    :disabled="disabled"
                    aria-label="Quantity"
                    class="w-full h-full text-center pr-[32px]"
                )
                    option(v-for="n in 10", :key="n", :value="n") {{ n }}
        div(
            class="h-full w-full"
            :class="{'rounded-l':!qtySelector.enabled,'border rounded-r':disabled}"
        )
            BaseButton(
                @click.native="addToCart"
                size='MEDIUM'
                :isDisabled="disabled"
                :isWaiting='wait'
                :isInline='true'
                class="h-full w-full"
                :class="{'rounded-l':!qtySelector.enabled}"
            ) {{ buttonText }}
</template>

<script>
import BaseButton from '@/components/baseButton'
export default {
    name: 'AddToCart',
    components: { BaseButton },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        sku: {
            // since we want the Add to Cart button to show, even when it's not 'ready' with a valid sku we just add a default b.s. value here
            type: String,
            default: '',
        },
        qtySelector: {
            type: Object,
            required: true,
        },
        isOutOfStock: {
            type: Boolean,
            default: false,
        },
        isPreOrder: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            qty: this.qtySelector.default,
            wait: false,
        }
    },
    computed: {
        buttonText() {
            if (this.isOutOfStock) return 'Out of Stock'
            if (this.isPreOrder) return 'Pre-Order Now'
            return 'Add to Cart'
        },
        lastItemAdded() {
            return this.$store.state.cart.popupCart.lastItem
        },
    },
    methods: {
        async addToCart() {
            // Double Click Protection
            if (this.wait) return

            this.wait = true

            const info = {
                productId: this.sku,
                qty: this.qty,
            }

            await this.$store.dispatch('cart/addItem', info).catch(() => {})
            // Now handle Installernet
            if (this.$installernet.enabled) {
                const quoteId = this.$installernet.getQuoteIdBySku(this.sku)
                if (quoteId) {
                    await this.$installernet
                        .addInstallation(
                            this.lastItemAdded.itemId,
                            quoteId,
                            this.$geolocation.city,
                            this.$geolocation.region
                        )
                        .catch((e) => {
                            this.$log.warning('installernet error', { e })
                        })
                    // Update the lastItem so it contains the installernet data
                    await this.$store.dispatch('cart/updateLastItem', this.sku).catch(() => {})
                    this.$uiEvents.$emit('installationAdded', this.lastItemAdded)
                }
            }

            if (this.$extend.enabled) await this.$extend.openModal(this.lastItemAdded)

            this.$overlay.show('mc')

            this.wait = false
        },
    },
}
</script>

<style lang="stylus" scoped>
// Override Button Default Styles
#app
    select
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
</style>
